import { createPortal } from 'react-dom';
export var ModalPortal = function (_a) {
    var isShowing = _a.isShowing, children = _a.children;
    if (typeof document === 'undefined') {
        return null;
    }
    var modalRootId = 'modal-root';
    if (!document.getElementById(modalRootId)) {
        var modalRoot = document.createElement('div');
        modalRoot.setAttribute('id', modalRootId);
        document.body.appendChild(modalRoot);
    }
    var modalRootElement = document.getElementById(modalRootId);
    if (!isShowing || !modalRootElement) {
        return null;
    }
    return createPortal(children, modalRootElement);
};
